import styled from "styled-components"

export default {
    "Label": styled.p`
        width: 100%;
        ${({ theme }) => theme.font.small};
        text-align: center;
        padding: 24px 0;
        color: ${({ theme }) => theme.color.black};
    `,
    "BtnDiv": styled.div`
        display: flex;
        gap: 8px;
    `,
}